import React, { useEffect, useState } from "react";
import { BsCalendar, BsBook, BsTelephone, BsEnvelope, BsGeoAlt, BsPencilSquare, BsBarChart, BsFileText, BsPerson } from "react-icons/bs";
import api from "../../api";

export default function Profile() {
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    course: "",
    batch: "",
    semester: "",
    attendance: "",
    gpa: "",
  });

  const [formData, setFormData] = useState({
    email: "",
    phone: "",
    address: "",
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}students/profile`);
        const data = response.data;

        setProfile({
          name: data.name || "N/A",
          email: data.email || "N/A",
          phone: data.phone || "N/A",
          address: data.address || "N/A",
          course: data.course || "N/A",
          batch: data.batch || "N/A",
          semester: data.semester || "N/A",
          attendance: data.attendance || "N/A",
          gpa: data.gpa || "N/A",
        });

        // Set form data for editing
        setFormData({
          email: data.email || "",
          phone: data.phone || "",
          address: data.address || "",
        });
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    };

    fetchProfile();
  }, []);

  return (
    <>
      <div className="max-w-full md:max-w-4xl mx-auto p-6 grid gap-6 md:grid-cols-3">
        {/* Profile Card */}
        <div className="bg-white p-4 rounded-lg shadow-md text-center md:col-span-1">
          <div className="flex justify-center mb-4">
            <div className="h-24 w-24 bg-gray-300 rounded-full flex items-center justify-center font-bold text-2xl">
              {profile.name.charAt(0)}
            </div>
          </div>
          <h2 className="text-xl font-semibold">{profile.name}</h2>
        </div>
        

        {/* Contact & Performance */}
        <div className="bg-white p-4 rounded-lg shadow-md md:col-span-2">
          <h3 className="text-lg font-semibold mb-4">Contact Information</h3>
          <div className="space-y-2 text-sm text-gray-600">
            <p className="flex items-center"><BsEnvelope className="mr-2" /> {profile.email}</p>
            <p className="flex items-center"><BsTelephone className="mr-2" /> {profile.phone}</p>
          </div>

         
        </div>

        {/* Edit Modal */}
        {isEditing && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white p-6 rounded-lg shadow-md w-96">
              <h2 className="text-lg font-semibold mb-4">Edit Profile</h2>
              <label className="block text-sm font-medium">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full p-2 border rounded mb-2"
              />

              <label className="block text-sm font-medium">Phone</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                className="w-full p-2 border rounded mb-2"
              />

              <label className="block text-sm font-medium">Address</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                className="w-full p-2 border rounded mb-4"
              ></textarea>

              <div className="flex justify-end space-x-2">
                <button onClick={() => setIsEditing(false)} className="px-4 py-2 bg-gray-200 rounded">
                  Cancel
                </button>
                <button onClick={() => setIsEditing(false)} className="px-4 py-2 bg-blue-600 text-white rounded">
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
